import React, { useState, useEffect, useRef } from "react";
import { Axios } from "./config";
import "./App.css"; // Adjust the path as needed
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Pages/HomePage";
import Admin from "./Pages/Admin";
import TeamStatsPage from "./Pages/TeamStatsPage";
import Login from "./Pages/Login";
import LandingPage from "./Pages/LandingPage";
import Subscribe from "./Pages/Subscribe";
import Unsubscribe from "./Pages/Unsubscribe";
import Playing11 from "./Pages/Playing11";
import { AuthProvider } from "./Pages/Auth";
import { RequireAuth } from "./Pages/RequireAuth";

function App() {
  const [username, setUsername] = useState("");
  const [pw, setPW] = useState("");
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/:Format/:TeamName" element={<TeamStatsPage />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/playing11" element={<Playing11 />} />
          <Route path="/AdminLogin" element={<Login />} />
          <Route
            path="/Admin"
            element={
              <RequireAuth>
                <Admin />
              </RequireAuth>
            }
            exact
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
